import { FilterTypes } from "../filter/filter-types.js";
import { FilterLocations } from "../filter/filter-locations.js";
import { FilterDatesRange } from "../filter/filter-dates-range.js";
import { FilterSelectsRange } from "../filter/filter-selects-range.js";
import { FilterCheckboxList } from "../filter/components/checkbox-list.js";
import { FilterSelect } from "../filter/components/select.js";
import { FilterPrice } from "../filter/filter-price.js";
import { FilterUsedLabels } from "../filter/filter-used-labels.js";
import { FilterPagination } from "../filter/filter-pagination.js";
import { FilterOrdering } from "../filter/filter-ordering.js";
import { ResultsCount } from "../filter/results-count.js";
import { Overlay } from "../filter/overlay.js";
import { FilterButtons } from "../filter/filter-buttons.js";
import { FilterUsedLabelsCount } from "../filter/filter-used-labels-count.js";
import { DealBuilder } from "../filter/deal-builder.js";
import { BannerBuilder } from "../filter/banner-builder.js";
import { FilterHidden } from "../filter/components/hidden.js";
import { FilterFulltextSearch } from "../filter/filter-fulltext-search.js";
import { CalendarRange } from "../calendar/calendar-range.js";
import { PersonSelect } from "../shared/person-select.js";
import { diff } from "../../utils/diff.js";
import { Serializator } from "../../utils/serialize.js";

export const Filter = {
	autoUpdateTimeout: 1000,
	autoUpdateTimeoutID: null,
	enabledUpdate: true,
	autoUpdateMinBreakpoint: 768,

	node: document.querySelector(".js-filter"),
	parent: null,
	children: [],
	updateMode: "standard",

	pagination: null,
	resultsCount: null,
	overlay: null,
	buttons: null,
	calendarRange: null,
	firstVisit: false,

	previousFormData: {},

	selectors: {
		form: document.querySelector("form.js-filter"),
		results: document.querySelector(".js-filter--results"),
		contentHeadlines: document.querySelectorAll(".js-filter--content-headline"),
		contentText: document.querySelector(".js-filter--content-text"),
		bottomText: document.querySelector(".js-filter--bottom-text"),
		breadcrumbs: document.querySelector(".js-filter--breadcrumbs"),
		subcategories: document.querySelector(".js-filter--subcategories"),
		contentWrapper: document.querySelector(
			".c-category-header.js-show-more-content"
		),
		overlay: document.querySelector(".js-filter--overlay"),
		pagination: document.querySelector(".js-filter--pagination"),
		checkboxLists: Array.prototype.slice.call(
			document.querySelectorAll(".js-filter-checkbox-list")
		),
		selectLists: Array.prototype.slice.call(
			document.querySelectorAll(".js-filter-select")
		),
		hiddenInputs: Array.prototype.slice.call(
			document.querySelectorAll(FilterHidden.selector)
		),
	},

	init: function () {
		let self = this;

		if (!self.selectors.form) {
			return;
		}

		self.firstVisit = true;

		self.autoUpdateTimeout =
			self.selectors.form.dataset.autoUpdateTimeout ||
			self.autoUpdateTimeout;

		self.initUsedLabels();
		self.initUsedLabelsCount();

		self.initTypesFilter();
		self.initLocationsFilter();
		self.initDatesRangeFilter();
		self.initSelectsRangeFilter();
		self.initCheckboxListFilters();
		self.initSelectFilters();
		self.initPriceFilter();
		self.initPaginationFilter();
		self.initOrderingFilter();
		self.initFulltextSearchFilter();
		self.initHiddenInputsFilter();
		self.initResultsCount();
		self.initOverlay();
		self.initButtons();
		self.initCalendarRange();
		self.initPersonSelect();

		self.updateUsedLabels();
		self.previousFormData = self.getFormData();

		self.firstVisit = false;

		return self;
	},

	setForceUpdateMode() {
		let self = this;
		self.updateMode = "force";
	},

	setStandardUpdateMode() {
		let self = this;
		self.updateMode = "standard";
	},

	initUsedLabels: function () {
		let self = this;

		self.usedFilterLabels = new FilterUsedLabels(
			self,
			self,
			document.querySelector(FilterUsedLabels.selector)
		);
	},

	initUsedLabelsCount: function () {
		let self = this;

		self.usedFilterLabelsCount = new FilterUsedLabelsCount(
			document.querySelector(FilterUsedLabelsCount.selector)
		);
	},

	initTypesFilter: function () {
		let self = this;

		let node = self.selectors.form.querySelector(FilterTypes.selector);
		if (node) {
			self.children.push(new FilterTypes(self, self, node));
		}
	},

	initLocationsFilter: function () {
		let self = this;

		let node = self.selectors.form.querySelector(FilterLocations.selector);
		if (node) {
			self.children.push(new FilterLocations(self, self, node));
		}
	},

	initDatesRangeFilter: function () {
		let self = this;

		let node = self.selectors.form.querySelector(FilterDatesRange.selector);
		if (node) {
			self.children.push(new FilterDatesRange(self, self, node));
		}
	},

	initSelectsRangeFilter: function () {
		let self = this;

		let node = self.selectors.form.querySelector(
			FilterSelectsRange.selector
		);
		if (node) {
			self.children.push(new FilterSelectsRange(self, self, node));
		}
	},

	initCheckboxListFilters: function () {
		let self = this;

		self.selectors.checkboxLists.forEach((group) => {
			self.children.push(new FilterCheckboxList(self, self, group));
		});
	},

	initSelectFilters: function () {
		let self = this;

		self.selectors.selectLists.forEach((select) => {
			self.children.push(new FilterSelect(self, self, select));
		});
	},

	initPriceFilter: function () {
		let self = this;

		let node = self.selectors.form.querySelector(FilterPrice.selector);
		if (node) {
			self.children.push(new FilterPrice(self, self, node));
		}
	},

	initPaginationFilter: function () {
		let self = this;

		let node = self.selectors.form.querySelector(FilterPagination.selector);
		if (node) {
			self.pagination = new FilterPagination(self, self, node);
			self.children.push(self.pagination);
		}
	},

	initFulltextSearchFilter: function () {
		let self = this;

		let node = self.selectors.form.querySelector(
			FilterFulltextSearch.selector
		);
		if (node) {
			self.children.push(new FilterFulltextSearch(self, self, node));
		}
	},

	initOrderingFilter: function () {
		let self = this;

		let node = self.selectors.form.querySelector(FilterOrdering.selector);
		if (node) {
			self.children.push(new FilterOrdering(self, self, node));
		}
	},

	initHiddenInputsFilter: function () {
		let self = this;

		self.selectors.hiddenInputs.forEach((input) => {
			self.children.push(new FilterHidden(self, self, input));
		});
	},

	initResultsCount: function () {
		let self = this;

		let node = document.querySelector(ResultsCount.selector);

		if (node) {
			self.resultsCount = new ResultsCount(node, self);
		}
	},

	initOverlay: function () {
		let self = this;

		let node = document.querySelector(Overlay.selector);
		if (node) {
			self.overlay = new Overlay(node);
		}
	},

	initButtons: function () {
		let self = this;

		let node = document.querySelector(FilterButtons.selector);
		self.buttons = new FilterButtons(self, node);
	},

	childComponentChangedState: function () {
		let self = this;

		if (self.enabledUpdate) {
			self.update();
		}
	},

	initCalendarRange: function () {
		let self = this;

		if (self.node.querySelector('.c-tk-calendar-range__wrapper')) {
			self.calendarRange = new CalendarRange(self, self, self.node.querySelector('.c-tk-calendar-range__wrapper'));
			self.children.push(self.calendarRange);
		}
	},

	initPersonSelect: function () {
		let self = this;

		if (self.node.querySelector('.js-person-selector-wrapper')) {
			const personSelect = new PersonSelect(self, self, self.node.querySelector('.js-person-selector-wrapper'));
			self.children.push(personSelect);
		}
	},

	update: function (delay) {
		let self = this;

		if (self.isEnabledAutoUpdate() || self.updateMode === "force") {
			self.forceUpdate(delay);
		}
	},

	isEnabledAutoUpdate: function () {
		let self = this;
		return window.innerWidth > self.autoUpdateMinBreakpoint;
	},

	forceUpdate: function (delay) {
		let self = this;
		delay = delay || self.autoUpdateTimeout;

		self.buttons.inactiveAllGroups();

		// detect changes ~> && reset pagination back to start
		let data = self.getFormData();
		let changes = self.detectDataChanges(data);

		if (changes.length === 0 || self.firstVisit === true) {
			return;
		}

		if (changes.length > 1 || changes[0] !== "page") {
			self.pagination.setNumericMode();
			self.pagination.setValue(1);
		}
		self.previousFormData = data;

		self.updateUsedLabels();
		self.updateURL();
		self.registerResultsUpdate(delay);
		// self.setStandardUpdateMode();
	},

	updateUsedLabels: function () {
		let self = this;
		self.usedFilterLabels.setLabels(self.getFilterLabels());
		self.usedFilterLabelsCount.setLabels(self.getFilterLabels());
	},

	getFilterLabels: function () {
		let self = this;
		let labels = [];

		self.children.forEach((child) => {
			if (typeof child["getLabels"] === "function") {
				labels = labels.concat(child.getLabels());
			} else if (typeof child["getLabel"] === "function") {
				labels.push(child.getLabel());
			}
		});

		return labels.filter(Boolean);
	},

	updateURL: function () {
		let self = this;
		let query = self.getSerializedFormData();
		let url = this.node.dataset.filterUrl + (query ? "?" + query : "");

		history.pushState(null, null, url);
	},

	getSerializedFormData: function () {
		let self = this;

		return Serializator.serialize(self.getFormData());
	},

	getFormData: function () {
		let self = this;
		let data = [];

		self.children.forEach((child) => {
			if (typeof child["getFormData"] === "function") {
				data = { ...data, ...child.getFormData() };
			}
		});

		return data;
	},

	registerResultsUpdate: function (delay) {
		let self = this;
		self.abortPrevResultsUpdateRequest();

		window.clearTimeout(self.autoUpdateTimeoutID);
		self.autoUpdateTimeoutID = setTimeout(self.updateResults, delay);
	},

	existPrevResultsUpdateRequest: function () {
		let self = this;

		return self.xhr && self.xhr.readyState !== 4;
	},

	abortPrevResultsUpdateRequest: function () {
		let self = this;

		if (self.existPrevResultsUpdateRequest()) {
			self.xhr.abort();
		}
	},

	callChildrenOnFilterUpdate: function () {
		let self = this;
		let autoUpdate = self.isEnabledAutoUpdate();

		self.children.forEach((child) => {
			if (typeof child["onFilterUpdate"] === "function") {
				child["onFilterUpdate"](autoUpdate);
			}
		});
	},

	updateResults: function () {
		let self = window.Filter;
		let requestURL = self.selectors.form.action + window.location.search;

		self.callChildrenOnFilterUpdate();

		if (!self.existPrevResultsUpdateRequest()) {
			self.overlay.activate();
		}

		self.xhr = new XMLHttpRequest();
		self.xhr.open("GET", requestURL);
		self.xhr.send();
		self.xhr.onreadystatechange = function () {
			if (self.xhr.readyState === 4) {
				if (self.xhr.status === 200) {
					self.overlay.deactivate();

					let response = JSON.parse(self.xhr.response);

					self.updateTexts(response);
					self.renderResults(response);
					self.updatePagination(response);
					self.updateResultsCount(response);
					self.updateFilters(response);
					self.updateDealsMap(response);
				} else if (self.xhr.status !== 0) {
					self.overlay.deactivate();
					console.error("Failed with status", self.xhr.status);
				}
			}
		};
	},

	renderResults: function (results) {
		let self = this;
		let html = "";

		let dealBuilder = new DealBuilder();
		let bannerBuilder = new BannerBuilder();

		let exported = false;
		for (let key in results["data"]) {
			if (!results["data"].hasOwnProperty(key)) {
				continue;
			}

			let data = results["data"][key];
			if (data["is_banner"]) {
				if (data['type'] === 'article') {
					html += dealBuilder.buildArticleBanner(data);
				} else {
					html +=
						data["size"] === "wide"
							? bannerBuilder.buildWide(data)
							: bannerBuilder.buildThin(data);
				}
			} else {

				if (typeof data['banner'] !== 'undefined') {
					let bannerType = data['banner']['type'];

					if (bannerType === 'staff_review') {
						html += dealBuilder.buildStaffReview(data);
					}

					if (bannerType === 'customer_review') {
						html += dealBuilder.buildCustomerReview(data);
					}

					if (bannerType === 'interesting_about') {
						html += dealBuilder.buildInterestingAbout(data);
					}

				} else if (data['type'] === 'cottage') {
					html += dealBuilder.buildCottage(data);
				} else {
					html += dealBuilder.build(data);
				}

			}

			exported = true;
		}

		if (!exported && results["emptyResult"]) {
			html =
				'<p class="c-filter__empty-results">' +
				results["emptyResult"] +
				"</p>";
		}

		// keep the scroll position
		const currentPos = window.scrollY || document.documentElement.scrollTop;

		if (
			!self.pagination ||
			self.pagination.mode === FilterPagination.modeNumeric
		) {
			self.selectors.results.innerHTML = html;
		} else {
			self.selectors.results.insertAdjacentHTML("beforeend", html);
		}

		// keep the scroll position
		window.scrollTo({
			top: currentPos,
		});

		// load images
		window.Slider.init();
		window.LazyImage.init();
		//window.Favorite.init();
		window.Favorite2024.init();
	},

	updatePagination: function (data) {
		let self = this;

		self.pagination.update(
			parseInt(data["current_page"]),
			parseInt(data["last_page"]),
			data["icons"]
		);
	},

	updateResultsCount: function (data) {
		let self = this;

		if (!self.resultsCount) {
			return;
		}

		// alert(data["total"]);
		self.resultsCount.update(parseInt(data["total"]));
	},

	updateDealsMap: function (data) {
		window.DealsMap.updateMarkers(data.pins);
	},

	updateFilters: function (data) {
		Array.from(this.node.getElementsByTagName("input")).forEach((n) => {
			if (n.id.includes("dostupnost") || n.id.includes("cena")) {
				return;
			}

			if (data.availableFilters && data.availableFilters.indexOf(n.id) === -1) {
				n.disabled = true;

				let label = document.querySelector('label[for="' + n.id + '"]');
				if (label) {
					label.classList.add(
						"c-checkbox--disabled",
						"c-checkbox--greyed-out"
					);
					Array.from(label.children).forEach((ch) => {
						ch.classList.add(
							"c-checkbox--disabled",
							"c-checkbox--greyed-out"
						);
					});
				}
			} else {
				n.disabled = false;

				let label = document.querySelector('label[for="' + n.id + '"]');
				if (label) {
					label.classList.remove(
						"c-checkbox--disabled",
						"c-checkbox--greyed-out"
					);
					Array.from(label.children).forEach((ch) => {
						ch.classList.remove(
							"c-checkbox--disabled",
							"c-checkbox--greyed-out"
						);
					});
				}
			}
		});
	},

	updateTexts: function (data) {
		let self = this;

		if (self.selectors.contentHeadlines.length) {
			self.selectors.contentHeadlines.forEach(header => {
				header.innerHTML = data.headline;
			})
		}

		if (self.selectors.contentText) {
			self.selectors.contentText.innerHTML = "";
		}

		if (self.selectors.bottomText) {
			self.selectors.bottomText.innerHTML = "";
		}
		if (self.selectors.subcategories) {
			self.selectors.subcategories.innerHTML = "";
		}
		if (self.selectors.breadcrumbs) {
			self.selectors.breadcrumbs.innerHTML = "";
		}

		if (self.selectors.contentWrapper) {
			self.selectors.contentWrapper.style.height = "auto";
			self.selectors.contentWrapper.classList.remove(
				"c-show-more-content"
			);
		}

		document.title = data.title;
	},

	detectDataChanges: function (newValues) {
		let self = this;

		return Object.keys(diff(self.previousFormData, newValues));
	},
};

window.Filter = Filter.init();
